import { CasButton } from 'src/compass/shared/components';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import Iconify from 'src/components/iconify';

import { StatusButtonConfig } from './ClaimTrackingStatusActions';

type ClaimTrackingButtonProps = {
  button: StatusButtonConfig;
  endorsementId: number;
  onUpdated: Function;
  onDialogChange: React.Dispatch<React.SetStateAction<StatusButtonConfig | null>>;
};

export default function ClaimTrackingStatusButton({
  button,
  endorsementId,
  onUpdated,
  onDialogChange,
}: ClaimTrackingButtonProps) { 
  const { label, url, icon, color, dialog, payload, showAsLink } = button;

  const { mutate } = useUpdateMutation({
    url,
    onSuccess: (response) => {
      onSuccessEnqueueSnackbar(response);
      onUpdated();
      return response;
    },
  });

  const handleClick = () => {
    if (dialog) onDialogChange(button);
    else mutate({ endorsementId, ...payload });
  };

  return (
    <CasButton
      startIcon={<Iconify icon={icon ?? ''} />}
      variant={showAsLink ? 'text' : 'outlined'}
      color={color}
      onClick={handleClick}
    >
      {label}
    </CasButton>
  );
}
